/**
 * Farlo UI | CRM
 *
 * @author Farlo
 */

// Farlo UI MC
class FarloUiCrm {
	constructor(_config) {
		const _self = this;
		let _instance = null;
		let crmAjaxHandler = null;

		if (typeof farloUiMcAjaxHandler !== 'undefined') {
			crmAjaxHandler = farloUiMcAjaxHandler;
		} else if (typeof farloUiSpektrixAjaxHandler !== 'undefined') {
			crmAjaxHandler = farloUiSpektrixAjaxHandler;
		} else {
			crmAjaxHandler = farloAjaxHandler;
		}

		this.config = {
			formId: '',
			nextBtn: '.farlo-ui-crm__next',
			prevBtn: '.farlo-ui-crm__prev',
			navContainer: '.farlo-ui-crm__nav',
			closeBtn: '.farlo-ui-crm__close',
			tabClass: '.farlo-ui-crm__tab',
			stepsClass: '.farlo-ui-crm__step',
			initData: null,
			startPage: 0,
			validateFirst: false
		};
		this.params = {
			initialised: false,
			currentStep: 0,
			totalSteps: 0,
			emailHash: '',
			data: new FormData()
		};

		this.customEvent = (_name, _detail) => {
			const customEvent = new CustomEvent(_name, {
				detail: _detail
			});
			window.dispatchEvent(customEvent);
		};
		this.customEvents = {
			farloSignupFormStarted: new CustomEvent('farloSignupFormStarted', {
				detail: {
					'event': 'Signup Form Started',
					'data': _self.page_data
				}
			}),

			farloSignupStageComplete: new CustomEvent('farloSignupStageComplete', {
				detail: {
					'event': 'Signup Stage Complete',
					'data': _self.page_data
				}
			}),

			farloSignupFormComplete: new CustomEvent('farloSignupFormComplete', {
				detail: {
					'event': 'Signup Form Complete',
					'data': _self.page_data
				}
			})

		};

		this.init = (config) => {
			if (_self.params.initialised) {
				_self.customEvents();
				_self.toggleForm();
			}
			window._farlo.events.push('Signup', 'Started');
			_self.customEvent('farloSignupFormStarted', {
				'event': 'Signup Form Started'
			});
			//window.dispatchEvent(_self.customEvents.farloSignupFormStarted);

			if (typeof config === 'string') {
				_self.config.formId = config;
			} else if (typeof config === 'object') {
				_self.config = {
					..._self.config,
					...config
				};
			} else {
				console.log('No Form ID set');
				return false;
			}
			_instance = document.getElementById(_self.config.formId);
			_self.params.totalSteps = _instance.querySelectorAll(_self.config.stepsClass).length;
			if (_self.params.totalSteps === 1) {
				_instance.querySelector(_self.config.stepsClass).style.display = 'none';
			}

			if (_self.config.initData) {
				for (const i in _self.config.initData) {
					if (_instance.querySelector('#' + i)) {
						if (_instance.querySelector('#' + i).type === 'checkbox') {
							_instance.querySelector('#' + i).checked = _self.config.initData[ i ];
						} else {
							_instance.querySelector('#' + i).value = _self.config.initData[ i ];
						}
					}
				}
				if (_self.config.validateFirst) {
					_self.nextPrev(1);
				} else {
					_self.showPage(_self.config.startPage);
				}
			} else {
				_self.showPage(_self.config.startPage);
			}

			if (!_instance.classList.contains('crm-inline')) {
				_self.toggleForm();
			}

			_instance.querySelector(_self.config.nextBtn).addEventListener('click', () => {
				_self.nextPrev(1);
			});
			_instance.querySelector(_self.config.prevBtn).addEventListener('click', () => {
				_self.nextPrev(-1);
			});
			_instance.querySelectorAll(_self.config.closeBtn).forEach((btn) => {
				btn.addEventListener('click', (e) => {
					e.stopImmediatePropagation();
					_self.toggleForm();

					if (btn.parentNode.parentNode && btn.parentNode.parentNode.classList.contains('farlo-ui-crm__tab-complete')) {
						btn.parentNode.parentNode.style.display = 'none';
					}
				});
			});
			_self.params.initialised = true;
		};

		this.toggleForm = () => {
			if (_instance.style.display === 'flex') {
				_instance.style.display = 'none';
				document.body.classList.remove('farlo-crm-open');
			} else {
				_instance.style.display = 'flex';
				document.body.classList.add('farlo-crm-open');
			}
		};

		this.submitData = (n, x) => {
			_self.params.data.append('action', 'farlo-ui-modify-subscriber');
			_self.params.data.append('nonce', farloUiMcAjaxHandler.nonce);
			_self.params.data.append('hash', _self.params.emailHash);
			if (_farlo.storage.get('_farlo_source', 'session')) {
				_self.params.data.append('FARLO_UI_MC_SOURCE', _farlo.storage.get('_farlo_source', 'session'));
			}

			let param_name;
			_self.page_data = {};

			x[ _self.params.currentStep ].querySelectorAll('.farlo-ui-crm__textbox').forEach((el) => {
				if (el.value !== '') {
					param_name = 'FARLO_UI_MC_' + el.id;
					_self.params.data.append(param_name, el.value);
					_self.page_data[ param_name ] = el.value;
				}
			});
			x[ _self.params.currentStep ].querySelectorAll('.farlo-ui-crm__hidden').forEach((el) => {
				if (el.value !== '') {
					param_name = 'FARLO_UI_MC_' + el.id;
					_self.params.data.append(param_name, el.value);
					_self.page_data[ param_name ] = el.value;
				}
			});
			x[ _self.params.currentStep ].querySelectorAll('.farlo-ui-crm__form-item-single_checkbox').forEach((field) => {
				const el = field.querySelector('.farlo-ui-crm__input');
				if (el.checked !== '') {
					param_name = 'FARLO_UI_MC_' + el.id;
					_self.params.data.append(param_name, el.value);
					_self.page_data[ param_name ] = el.value;
				}
			});
			x[ _self.params.currentStep ].querySelectorAll('.farlo-ui-crm__form-item-single_choice_field').forEach((field) => {
				let id = field.querySelector('.farlo-ui-crm__choice').id;
				id = id.replace('farlo-ui-crm__choice-', '');
				const choices = [];
				field.querySelectorAll('.farlo-ui-crm__input').forEach((el) => {
					if (el.checked) {
						choices.push(field.querySelector("label[for='" + el.id + "']").innerText);
					}
				});
				param_name = 'FARLO_UI_MC_' + id;
				_self.params.data.append(param_name, choices.toString());
				_self.page_data[ param_name ] = choices.toString();
			});

			x[ _self.params.currentStep ].querySelectorAll('.farlo-ui-crm__form-item-multiple_choice_field').forEach((field) => {
				let id = field.querySelector('.farlo-ui-crm__choice').id;
				id = id.replace('farlo-ui-crm__choice-', '');
				const choices = [];
				field.querySelectorAll('.farlo-ui-crm__input').forEach((el) => {
					if (el.checked) {
						choices.push(field.querySelector("label[for='" + el.id + "']").innerText);
					}
				});
				param_name = 'FARLO_UI_MC_' + id;
				_self.params.data.append(param_name, choices.toString());
				_self.page_data[ param_name ] = choices.toString();
			});

			window._farlo.events.generic(_self.page_data);
			window._farlo.events.push('Signup', 'Stage Complete', (_self.params.currentStep + 1));
			_self.customEvent('farloSignupStageComplete', {
				'event': 'Signup Stage Complete',
				'data': _self.page_data,
				'stage': (_self.params.currentStep + 1)
			});
			window._farlo.storage.set('_farlo_crm', _self.page_data);

			fetch(farloUiMcAjaxHandler.ajaxurl, {
				method: 'POST',
				credentials: 'same-origin',
				body: _self.params.data
			}).then((response) => response.json()).then((data) => {
				if (!data || !data.success) {
					throw new Error(`Request failed with status ${ data.detail }`);
				}
				if (data.data.email_hash) {
					_self.params.emailHash = data.data.email_hash;
				}

				x[ _self.params.currentStep ].classList.remove('loading');
				x[ _self.params.currentStep ].style.display = 'none';
				_self.params.currentStep = _self.params.currentStep + n;
				_self.showPage(_self.params.currentStep);
			});
		};

		this.showPage = (n) => {
			_instance.querySelector(_self.config.navContainer).style.display = 'flex';
			const x = _instance.querySelectorAll(_self.config.tabClass);
			x[ n ].style.display = 'block';
			if (n === 0) {
				_instance.querySelector(_self.config.prevBtn).style.display = 'none';
			} else {
				_instance.querySelector(_self.config.prevBtn).style.display = 'inline';
			}
			if (n === (x.length - 2)) {
				_instance.querySelector(_self.config.nextBtn).innerHTML = 'Enter';
			} else {
				_instance.querySelector(_self.config.nextBtn).innerHTML = 'Next';
			}
			if (n === (x.length - 1)) {
				_instance.querySelector(_self.config.navContainer).style.display = 'none';
			}
			_self.indicatorStep(n);
		};

		this.nextPrev = (n) => {
			if (n === 1 && !_self.validatePage()) {
				return false;
			}
			const x = _instance.querySelectorAll(_self.config.tabClass);

			if (n === 1) {
				x[ _self.params.currentStep ].classList.add('loading');
				_self.submitData(n, x);
			} else {
				x[ _self.params.currentStep ].style.display = 'none';
				_self.params.currentStep = _self.params.currentStep + n;
				_self.showPage(_self.params.currentStep);
			}
		};

		this.validatePage = () => {
			let i,
				valid = true;
			const x = _instance.querySelectorAll(_self.config.tabClass);
			const y = x[ _self.params.currentStep ].getElementsByTagName('input');
			for (i = 0; i < y.length; i ++) {
				if (y[ i ].type === 'email') {
					if (!window._farlo.helpers.validators.email(y[ i ].value)) {
						y[ i ].className += ' invalid';
						valid = false;
					}
				} else if (y[ i ].type === 'checkbox' && y[ i ].required) {
					if (!y[ i ].checked) {
						y[ i ].className += ' invalid';
						valid = false;
					}
				} else if (y[ i ].value === '' && y[ i ].required) {
					y[ i ].className += ' invalid';
					valid = false;
				}
			}
			if (valid) {
				_instance.querySelectorAll(_self.config.stepsClass)[ _self.params.currentStep ].className += ' finish';
			}
			return valid;
		};

		this.indicatorStep = (n) => {
			if (n < _self.params.totalSteps) {
				let i;
				const x = _instance.querySelectorAll(_self.config.stepsClass);
				for (i = 0; i < x.length; i ++) {
					x[ i ].className = x[ i ].className.replace(' active', '');
				}
				x[ n ].className += ' active';
			} else {
				window._farlo.events.push('Signup', 'Complete');
				_self.customEvent('farloSignupFormComplete', {
					'event': 'Signup Form Complete',
					'data': _self.page_data
				});
			}
		};

		_self.init(_config);
	}
}

export default FarloUiCrm;
